var map = {
	"./acv_playingSoccer.png": "Hjc9",
	"./acv_sickParent.png": "KI2E",
	"./acv_twoFiguresTalking.png": "iCCW",
	"./andrea_ferro.png": "mxrh",
	"./cartoon_stories_1.png": "QtrZ",
	"./cartoon_stories_3.png": "tvqf",
	"./continuum.png": "aG9B",
	"./kids_playing_arm_up.png": "mDzZ",
	"./kids_sitting_1.png": "6jOn",
	"./logo_final.png": "Rbo6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sZwx";


//////////////////
// WEBPACK FOOTER
// ./src/assets \.png$
// module id = sZwx
// module chunks = 0